import { BaseNimbleAPI } from '../../../api/baseAPI';

class CandidateMatchQuizAPI extends BaseNimbleAPI {
  get config() {
    return { baseURL: '/api/connect-match-quiz' };
  }

  async getMatchQuizStatus(candidate_id: number, detailed: boolean = false): Promise<any> {
    const response = await this.get(`/status?candidate_id=${candidate_id}&detailed=${detailed}`);
    return response.data;
  }
}

export default new CandidateMatchQuizAPI();
